export interface Application {
  applicationId: number; // TODO
  applicationCode: string; // TODO
  applicationName: string;
  applicationDesc: string;
}
